// Built-ins
import { useState } from "react";

// Icons / Images
import { FiEdit2 } from "react-icons/fi";
import { AiOutlineWarning, AiOutlineCheckCircle } from "react-icons/ai";

// Modules / Functions
import { Modal } from "react-bootstrap";
import axios from "axios";
import { Button } from "semantic-ui-react";
import Swal from "sweetalert2";
import { BsInfoSquare } from "react-icons/bs";

// Global Variables
import { headers } from "../../global_vars";

// Variables
window.Swal = Swal;

let warningStyle = {
  fontSize: 18,
  marginRight: 6,
};

let checkStyle = {
  fontSize: 18,
  marginRight: 6,
};

const CHANGE_GPS_DATA_SIM_CARD =
  "https://groupplan.gr/api/data_management/change_gps_data_sim_card/";

function ChangeGPSDataSimCard(props) {
  const [show, setShow] = useState(false);
  const [gps_data_sim_card, setGPSDataSimCard] = useState(
    props.gps_data_sim_card ? props.gps_data_sim_card : ""
  );
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const update_GPSDataSimCard = () => {
    axios({
      method: "post",
      url: CHANGE_GPS_DATA_SIM_CARD,
      headers: headers,
      data: {
        coach_id: props.coach_id,
        gps_data_sim_card: gps_data_sim_card,
      },
    })
      .then((res) => {
        props.update_state(res.data.coach);
      })
      .catch((e) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: e.response.data.errormsg,
        });
      });
  };

  return (
    <>
      <FiEdit2
        title={"edit coach's plate number"}
        id={"edit_coach_name"}
        onClick={() => {
          handleShow();
        }}
        className={"edit_icon"}
      />
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change GPS Data Sim Card for {props.make}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="number"
            maxLength="50"
            value={gps_data_sim_card}
            style={{ width: 240 }}
            className="form-control"
            onChange={(e) => setGPSDataSimCard(e.currentTarget.value)}
          ></input>
        </Modal.Body>
        <Modal.Footer>
          <small className="mr-auto">
            <BsInfoSquare
              style={{
                color: "#F3702D",
                fontSize: "1.5em",
                marginRight: "0.5em",
              }}
            />
            Coach's GPS Data Sim Card is an integer field
            {gps_data_sim_card.length < 4 ? (
              <>
                <ul
                  className="mr-auto"
                  style={{ margin: 0, padding: 0, marginTop: 10, color: "red" }}
                >
                  <li>
                    {gps_data_sim_card.length < 4 ? (
                      <>
                        <AiOutlineWarning style={warningStyle} />
                        Fill The GPS Data Sim Card Field.
                      </>
                    ) : (
                      ""
                    )}
                  </li>
                </ul>
              </>
            ) : (
              <>
                <ul
                  className="mr-auto"
                  style={{
                    margin: 0,
                    padding: 0,
                    marginTop: 10,
                    color: "green",
                  }}
                >
                  <li>
                    <AiOutlineCheckCircle style={checkStyle} />
                    Validated
                  </li>
                </ul>
              </>
            )}
          </small>
          <Button color="red" onClick={handleClose}>
            Close
          </Button>
          <Button
            color="green"
            disabled={gps_data_sim_card.length < 4}
            onClick={() => {
              handleClose();
              update_GPSDataSimCard();
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ChangeGPSDataSimCard;
